import { render, staticRenderFns } from "./EmptyPagesList.vue?vue&type=template&id=21a10b26&scoped=true&"
import script from "./EmptyPagesList.vue?vue&type=script&lang=js&"
export * from "./EmptyPagesList.vue?vue&type=script&lang=js&"
import style0 from "./EmptyPagesList.vue?vue&type=style&index=0&id=21a10b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a10b26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
